export const ReviewSourceLabels = {
  SEEDED: 'Seeded',
  EMPLOYEE: 'Employee',
};
